// GetWalletPage returns data for rendering a coupon wallet page
// NOTE: for backwards compatibility this will return an empty page instead of a disabled coupon page
export const CouponsService_GetWalletPageLazy = () =>
  import("./service.grpc").then((m) => m.CouponsService_GetWalletPage);
CouponsService_GetWalletPageLazy.method =
  "aysa_api.services.coupons.v1.wallet.CouponsService/GetWalletPage" as const;

// Coupon Wallet Page + Slot Machine
export const CouponsService_GetWalletLazy = () =>
  import("./service.grpc").then((m) => m.CouponsService_GetWallet);
CouponsService_GetWalletLazy.method =
  "aysa_api.services.coupons.v1.wallet.CouponsService/GetWallet" as const;

// Coupon Wallet v2 Page (Section based)
export const CouponsService_GetWalletV2Lazy = () =>
  import("./service.grpc").then((m) => m.CouponsService_GetWalletV2);
CouponsService_GetWalletV2Lazy.method =
  "aysa_api.services.coupons.v1.wallet.CouponsService/GetWalletV2" as const;

// GetCoupons returns a plain list of coupons ids
export const CouponsService_GetCouponsLazy = () =>
  import("./service.grpc").then((m) => m.CouponsService_GetCoupons);
CouponsService_GetCouponsLazy.method =
  "aysa_api.services.coupons.v1.wallet.CouponsService/GetCoupons" as const;

// GenerateWelcomeToAppCoupon is used to generate a new coupon on a user's first app installation
export const CouponsService_GenerateWelcomeToAppCouponLazy = () =>
  import("./service.grpc").then(
    (m) => m.CouponsService_GenerateWelcomeToAppCoupon
  );
CouponsService_GenerateWelcomeToAppCouponLazy.method =
  "aysa_api.services.coupons.v1.wallet.CouponsService/GenerateWelcomeToAppCoupon" as const;
